import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss']
})
export class ReportSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
